import { Card, Table, Button } from "react-bootstrap";
import { startTransition, useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {ArrowLeftCircle} from "react-bootstrap-icons";
import clsx from "clsx";
import userDetails from "./UserDetails";
import UserDetails from "./UserDetails";
import AddCustomerModal from "../modal/AddCustomerModal";
import { useLazyGetAccessGroupUsersQuery } from "app/redux/Users/Accessusers/accessUsersApi";
import { accessUserAction } from "app/redux/Users/Accessusers/accessUserSlice";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import {useLazyGetAMSVendorSyncAccessUsersQuery} from "app/redux/AMS/amsApi";
import {amsVendorSyncAccessUsersAction} from "app/redux/AMS/amsSlice";
import { useLazyGetFacilityDetailsForCompanyQuery } from "app/redux/Facility/facilityApi";
import {companyAccessPointAction} from "app/redux/Facility/facilitySlice";
import { array } from "yup";
import { forEach } from "lodash";

function AccessUsers() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const dispatch = useDispatch();
  const { selectedCompanyId } = useSelector((state) => state.company);
  const [userloading, setUserLoading] = useState(false);
  const [getAccessGroupUsers] = useLazyGetAccessGroupUsersQuery();
  const [getAMSVendorSyncAccessUsers] = useLazyGetAMSVendorSyncAccessUsersQuery();
  const [getFacilityDetailsForCompany] = useLazyGetFacilityDetailsForCompanyQuery();
  const [inputValue, setInputValue] = useState("");
  const [accessUserListData, setStateAccessUserListData] = useState([]);
  const [amsUserListData, setStateAmsUserListData] = useState([]);
  const [searchList, setState] = useState([]);
  const [key, setKey] = useState(0);
  const [modalState, setModalState] = useState({
    eventObject: {},
    eventDialogOpen: false,
   
  });
  const [addCustomerModalState, setAddCustomerModalState] = useState({
    dialogValues: null,
    showEditorDialog: false
  });
  
  let fullAccessUserList = useSelector((state) => {
    return state.accessUser.accessUserList;
  });

  let accessUserList = useSelector((state) => {
    const userlist = state.accessUser.accessUserList;
    if(userlist && userlist.length > 0){
      return userlist;//.filter(a => a.IsArchive === false);
    }
    else{
      return state.accessUser.accessUserList;
    }
  });

  let amsVendorSyncAccessUserList = useSelector((state) => {
    return state.ams.amsVendorSyncAccessUsersList;
  });

  let companyAccessPointList = useSelector((state) => {
    return state.facility.companyAccessPointList;
  });


  useEffect(() => {
    //setStateAccessUserListData(accessUserList);
    //setState(accessUserList);
    if(!accessUserList || (accessUserList && accessUserList.length <= 0))
    {
      getAccessGroupUSerList('load');
    }
    else if(!amsVendorSyncAccessUserList || amsVendorSyncAccessUserList.length <= 0){
      getAMSVendorSyncAccessUserList();
    }
    else if(!companyAccessPointList || companyAccessPointList.length <= 0){
      getFacilityDetailsForCompanyList();
    }
  }, []);

  const mergeUserListData = (amsUserData, vendorAccessUserData, accessPointData) => {
    let vendorUserData = JSON.parse(JSON.stringify(vendorAccessUserData));
    vendorUserData.forEach((vendorItem) => {
      const userid = vendorItem.UserId;
      if(!vendorItem['AccessGroups']){
        vendorItem['AccessGroups'] = [];
      }
      const chkInAMS = amsUserData.filter(a => a.vendorCustomerId === userid);
      if(chkInAMS && chkInAMS.length > 0){
        const amsItem = chkInAMS[0];
        const getCustomGroup = amsItem.accessGroups.filter(a => a.type === 'custom');
        if(getCustomGroup && getCustomGroup.length > 0){
          getCustomGroup.forEach((amsAccessGroupItem) => {
            let objGroup = {};
            objGroup['AccessGroup'] = amsAccessGroupItem.name;
            objGroup['AccessId'] = amsAccessGroupItem.vendorAccessGroupId;
            objGroup['AccessType'] = amsAccessGroupItem.type;
            objGroup['amsAccessGroupId'] = getCustomGroup.amsAccessGroupId;
            vendorItem['AccessGroups'].push(objGroup);
          });
        }

        const getAccessPoints = amsItem.accessPoints;
        if(getAccessPoints && getAccessPoints.length > 0){
          getAccessPoints.forEach((amsAccessPointItem) => {
            const FacilityId = amsAccessPointItem.vendorId;
            const amsAccessPointId = amsAccessPointItem.amsAccessId;
            if(!vendorItem.AccessPoints || vendorItem.AccessPoints.length < 0){
              vendorItem.AccessPoints = [];
            }
            //if(vendorItem.AccessPoints && vendorItem.AccessPoints.length > 0){
              const checkInVendor = vendorItem.AccessPoints.filter(a => a.FacilityId === FacilityId);
              if(!checkInVendor || checkInVendor.length <= 0){
                const getAccessPointsDetail = accessPointData.filter(a => a.FacilityId === FacilityId);
                if(getAccessPointsDetail && getAccessPointsDetail.length > 0){
                  const accessPointDetail = getAccessPointsDetail[0];
                  let objAccessPoints = {};
                  objAccessPoints['FacilityId'] = FacilityId;
                  objAccessPoints['FacilityName'] =    accessPointDetail.FacilityName;
                  objAccessPoints['amsAccessPointId'] = amsAccessPointId;
                  vendorItem.AccessPoints.push(objAccessPoints);
                }
              }
            //}
          });
        }
        if(vendorItem.AccessPoints && vendorItem.AccessPoints.length > 0){
          vendorItem.AccessPointCount = vendorItem.AccessPoints.length + ' av ' + accessPointData.length;
        }
        


      }
   });
   setState(vendorUserData);
   setStateAccessUserListData(vendorUserData);
  }

  const getAMSVendorSyncAccessUserList = async() => {
    let amsUserData = [];
    showLoader();
    new Promise((resolve, reject) => {
      getAMSVendorSyncAccessUsers({
        companyId: selectedCompanyId
      }).then((result) => {
        hideLoader();
        if (result.isSuccess) {
          amsVendorSyncAccessUserList = result.data;
          amsUserData =  result.data;
          dispatch(
            amsVendorSyncAccessUsersAction({
              amssynccompanyAccessGroupList: result.data,
            })
          );
          if(!companyAccessPointList || companyAccessPointList.length <= 0){
            getFacilityDetailsForCompanyList();
          }
          else{
            mergeUserListData(amsUserData, accessUserList, companyAccessPointList);
          }
        }
      }, error => {
        hideLoader();
      });
    });
    
    return amsUserData;
  }

  const getFacilityDetailsForCompanyList = async () => {
    getFacilityDetailsForCompany({
      companyId: selectedCompanyId,
      type: "GET_ACCESSPOINT",
    }).then((result) => {
      //setAccessPointLoading(false);
      if (result.data.data?.length > 0) {
        //setAccessPointCount(result.data.data);
        let modifiedData = modifyData(result.data.data);
        companyAccessPointList = modifiedData;
        dispatch(
          companyAccessPointAction({
            companyAccessPointList: modifiedData,
          })
        );
        mergeUserListData(amsVendorSyncAccessUserList, accessUserList, companyAccessPointList);
      }
    });

  };

  const modifyData = (data) => {
    return data.map((item) => ({
      ...item,
      isEdit: false,
      selectedItem: []
    }));
  };

  

  const handleSearch = (event) => {
    let tempaccessUserListData = accessUserListData;
    event.persist();
    setInputValue(event.target.value);
    startTransition(() => {
      const filterSearch = tempaccessUserListData.filter((item) =>
        (item.CustomerName && item.CustomerName.toLowerCase().match(event.target.value.toLowerCase())) ||
        (item.Email && item.Email.toLowerCase().match(event.target.value.toLowerCase())) ||
        (item.Phone && item.Phone.toLowerCase().match(event.target.value.toLowerCase()))
      );
      setState(filterSearch);
    });
  };

  const toggleEditorDialog = (arg) => {
    if (arg && arg.toString()) {
      setAddCustomerModalState((prevState) => ({ ...prevState, showEditorDialog: true, dialogValues: null }));
    } else {
      setAddCustomerModalState((prevState) => ({
        ...prevState,
        dialogValues: null,
        showEditorDialog: !addCustomerModalState.showEditorDialog
      }));
    }
  };

  const handleFormSubmit = async (values) => {
    getAccessGroupUSerList();
    toggleEditorDialog(false);
  };

  const getAccessGroupUSerList = (type) => {
    showLoader();
    getAccessGroupUsers({
      companyId: selectedCompanyId,
      type: "GET_ACCESSGROUP",
    }).then((result) => {
      setUserLoading(false);
      if (result.data.data?.length > 0) {
        accessUserList = result.data.data;
        setStateAccessUserListData(result.data.data,);
        setState(result.data.data,);
        dispatch(
          accessUserAction({
            accessUserList: result.data.data,
          })
        );
        if(type === 'load'){
          if(!amsVendorSyncAccessUserList || amsVendorSyncAccessUserList.length <= 0){
            getAMSVendorSyncAccessUserList();
          }
          else if(!companyAccessPointList || companyAccessPointList.length <= 0){
            getFacilityDetailsForCompanyList();
          }
        }
        else{
          getAMSVendorSyncAccessUserList();
        }
        hideLoader();
      }
    }, error => {
      hideLoader();
    });
  }


  const {
    eventObject,
    eventDialogOpen,
  } = modalState;

  
  const closeModal = (shouldRefresh) => {
    setKey(prevKey => prevKey + 1);
    setModalState((prev) => ({ ...prev, eventDialogOpen: false }));

    if (shouldRefresh === true) {
      // ONLY AFTER DELETE

      // clear search box
      setInputValue("");

      // clear filtered list
      setState([]);

      // reload fresh users
      getAccessGroupUSerList("refresh");
    }
  };

  const handleListOfAccessPointClick = (item) => {
    //AccessPoints
    setModalState((prevState) => ({
      ...prevState,
      eventDialogOpen: true,
      eventObject: { item: item}
    }));
  }
  let { dialogValues, showEditorDialog } = addCustomerModalState;

  return (
    <Fragment>
      {!eventDialogOpen &&
    <div>
      <div className="row" style={{alignItems: "baseline"}}>
            <div className="col-md-2">
                 <h1>Brukere</h1>
            </div>
            
            <div className="col-md-10 text-md-end">
                <button
                  type="button"
                  className="mt-2 mr-10 btn btn-outline-secondary btn-block mb-4"
                  style={{marginRight: "10px"}}
                  onClick={toggleEditorDialog}>
                  Legg til ny bruker
                </button>
                <Link to="/">
                  <Button className="mb-3" variant="primary">
                    <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                    Tilbake
                  </Button>
                </Link>
            </div>
      </div>

      <div >
        <input
          autoFocus
          type="text"
          placeholder="Søk navn, e-post, telefon"
          className="input-search-inputCustom"
          onChange={handleSearch}
          value={inputValue}
        />
      </div>
      
      <Card elevation={6} className="w-100 overflow-auto">
        <Table
          bordered
          className="table table-bordered tbl-custom"
          style={{ minWidth: 750 }}
        >
          <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
            <tr>
              <th className="py-3" align="left">
                Navn
              </th>
              <th className="py-3" align="left">
                E-post
              </th>
              <th className="py-3" align="left">
                Telefon
              </th>
              <th className="py-3" align="left">
                Eiendomsobjekter
              </th>
              <th className="py-3" align="left">
                Tilgangsgruppe
              </th>
              <th className="py-3" align="left">
                Aksesspunkt
              </th>
            </tr>
          </thead>

          {searchList.map((item, index) => (
            <tbody key={index}>
              <tr>
                <td className="py-3 capitalize" align="left">
                  <span className="cursor-pointer text-primary" onClick={() => handleListOfAccessPointClick(item)}>
                    {item.CustomerName} 
                  </span>
                </td>
                <td className="py-3 capitalize" align="left">
                  {item.Email}
                </td>
                <td className="py-3 capitalize" align="left">
                  {item.Phone}
                </td>
                <td align="left">
                  {item.PropertyUnits &&
                    item.PropertyUnits.map((puItem, puIndex) => {
                      return (
                        <div key={puItem + puIndex} className="mt-8">
                          <span>{puItem.Propertyunit}</span>
                        </div>
                      );
                    })}
                </td>
                <td align="left">
                  {item.AccessGroups &&
                    item.AccessGroups.map((groupItem, groupIndex) => {
                      return (
                        <div key={groupItem + groupIndex} className="mt-8">
                          <span>{groupItem.AccessGroup}</span>
                        </div>
                      );
                    })}
                </td>
                <td align="left">
                  {item.AccessPointCount}
                </td>
              </tr>
            </tbody>
          ))}
        </Table>
      </Card>
      
    </div>

    
}
  {eventDialogOpen &&
    <UserDetails open={eventDialogOpen} handleClose={closeModal} eventObject= {eventObject} />
  }
    <AddCustomerModal
        show={showEditorDialog}
        initialValues={dialogValues}
        handleFormSubmit={handleFormSubmit}
        toggleEditorDialog={toggleEditorDialog}
      />
    {loader}
    </Fragment>
    
  );
}

export default AccessUsers;
